module.exports = __webpack_public_path__ + "img/组 127@2x(1).05f26168.png";